/* global layoutChanges, canvas_data, previews */
import Template from "../../banner_template/Template";
import Player from '@frontend/group/modules/banner-player/Player';
import GroupFields, { EVENTS as EVENTS_GROUP_FIELDS } from '@frontend/preview/common/group-fields';
import BackgroundThemeImageMultipleList
  from '@frontend/draw_fields_template/background_theme_image_multiple/BackgroundThemeImageMultipleList';
import OutlineList from '@frontend/draw_fields_template/outline/OutlineList';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { parseJsonData } from '@frontend/services/helpers';
import {
  FIELD_TYPE_ADDITIONAL_FIELDS,
  FIELD_TYPE_BACKGROND_THEME_IMAGE_MULTIPLE,
  FIELD_TYPE_OUTLINE, FIELD_TYPE_SAFE_ZONE, FIELD_TYPE_SMART_OBJECT
} from '@frontend/constants/type-fields-of-template';
import BackgroundThemeImageMultipleField from '@/banner_template/fields/BackgroundThemeImageMultipleField';
import BackgroundThemeImageMultiple
  from '@frontend/draw_fields_template/background_theme_image_multiple/BackgroundThemeImageMultiple';
import BackgroundThemeImageMultipleInputData
  from '@frontend/draw_fields_template/background_theme_image_multiple/BackgroundThemeImageMultipleInputData';
import OutlineInputData from '@frontend/draw_fields_template/outline/OutlineInputData';
import Outline from '@frontend/draw_fields_template/outline/Outline';
import parseText from '@/common/preview/parse-text';
import { fabric } from 'fabric';
import { initDataBuilderTable } from '@frontend/group/modules/simple-table-builder/helpers';
import { drawBackgroundColor } from '@/common/preview/draw-background-color';
import { setBackgroundColor } from '@/common/preview/set-background-color';
import { drawBackgroundMockup } from '@/common/preview/draw-background-mockup';
import { drawRectangle } from '@/common/preview/draw-rectangle';
import { drawCircle } from '@/common/preview/draw-circle';
import { drawAdditionalRectangle } from '@/common/preview/draw-additional-rectangle';
import { drawAdditionalCircle } from '@/common/preview/draw-additional-circle';
import { drawHtml } from '@/common/preview/draw-html';
import { drawStaticText } from '@/common/preview/draw-static-text';
import { drawStroke } from '@/common/preview/draw-stroke';
import { drawMarker } from '@/common/preview/draw-marker';
import { drawLine } from '@/common/preview/draw-line';
import { drawImageList } from '@/common/preview/draw-image-list';
import { drawOverlayArea } from '@/common/preview/draw-overlay-area';
import { drawLayoutStroke } from '@/common/preview/draw-layout-stroke';
import { drawImageFromBackground } from '@/common/preview/draw-image-from-background';
import { drawStaticImage } from '@/common/preview/draw-static-image';
import { drawUploadedImage } from '@/common/preview/draw-upload-Image';
import { setAdditionalBackgroundImage } from '@/common/preview/set-additional-background-image';
import { drawUploadedBackgroundImage } from '@/common/preview/draw-uploaded-background-image';
import { drawText } from '@/common/preview/draw-text';
import { drawProductImage } from '@/common/preview/draw-product-image';
import { drawMultiLineText } from '@/common/preview/draw-multi-line-text';
import { drawAdditionalText } from '@/common/preview/draw-additional-text';
import { drawAdditionalMultiLineText } from '@/common/preview/draw-additional-multi-line-text';
import { drawTocLine } from '@/common/preview/draw-toc-line';
import {drawSmartObject, getGroupNameByAddFieldId} from '@/common/preview/draw-smart-object';
import { SHOW_PAGE_EVENTS, ShowPageEventBroker } from '@frontend/group/show-page-event';
import { CORNER_SIZE } from '@frontend/constants/fabric-constants';
import { drawSafeZone } from '@/common/preview/draw-safe-zone';
import { drawAdditionalSafeZone } from '@/common/preview/draw-additional-safe-zone';
import {
  ADDITIONAL_CIRCLE_PREFIX_ELEMENT_ID,
  ADDITIONAL_MULTI_LINE_TEXT_FIELD_PREFIX_ELEMENT_ID,
  ADDITIONAL_RECTANGLE_PREFIX_ELEMENT_ID,
  ADDITIONAL_TEXT_PREFIX_ELEMENT_ID,
  ADDITIONAL_SAFE_ZONE_PREFIX_ELEMENT_ID,
  ADDITIONAL_LINE_PREFIX_ID, SMART_OBJECT, 
  ADDITIONAL_CUT_LINE_PREFIX_ELEMENT_ID, 
  TOC_LINE_PREFIX_ID,
} from '@frontend/constants/templates-field-prefixes';
import { initStrokeSettings } from "@frontend/group/modules/stroke-settings/button-handler";
import { drawAdditionalIcons, drawIcons } from "@/common/preview/draw-icons";
import {drawAdditionalLine} from "@/common/preview/draw-additional-line";
import { drawAdditionalHtmlTable } from "@/common/preview/draw-additional-html-table";
import {drawTemplateGuidelines} from "@/common/preview/draw-template-guideline";
import {drawAdditionalCutLine} from "@/common/preview/draw-additional-cut-line";
import { CANVAS_EVENTS } from "@frontend/group/modules/editor-control-popup/event-broker";

const getScopePage = () => ShowPageScopeCollector.get([
  'canvas_data',
  'replaceBackgroundImage',
  'updateLayoutChanges',
  'setBackgroundImage',
  'reorderObjectCanvas',
  'canvasHistory',
  'layout_options',
]);
const RELATED_FIELD_DEFAULT = {
  field: '',
  margin: 5,
  move_down_only: false
};

const parseRelatedFieldOptions = (options) => {
  const parsedOption = parseJsonData(options['Option2'], RELATED_FIELD_DEFAULT);

  if (!parsedOption || typeof parsedOption !== 'object' || Array.isArray(parsedOption)) {
    return { ...RELATED_FIELD_DEFAULT };
  }

  return {
    ...RELATED_FIELD_DEFAULT,
    ...parsedOption
  };
};

export function initAdditionalBackgroundThemeImage(canvas_data, instanceId) {
  for (let i = 0; i <= canvas_data[instanceId]._data.additional_background_images.length - 1; i++) {
    let duplicateData = canvas_data[instanceId]._data.add_bk_img_duplicate_data[i];
    let order = 1000;

    if (canvas_data[instanceId]._data && canvas_data[instanceId]._data.add_bk_img_order) {
      order = canvas_data[instanceId]._data.add_bk_img_order[i];
    }

    if (duplicateData) {
      duplicateData = JSON.parse(duplicateData);
    }

    canvas_data[instanceId].additional_background_theme_image.push({
      'name': `BG theme image ${i} (add.)`,
      'left': 0,
      'top': 0,
      'width': duplicateData ? duplicateData.width : 0,
      'height': duplicateData ? duplicateData.height : 400,
      order,
      'crop': false,
      'moveable': true,
      'real_id': `additional-${i}`
    });
  }
}

export const drawPreviews = async (previews, canvasEventBroker) => {
  defaultViewInit();
  
  const promises = [];
  const boundingBoxData = [];
  
  const {
    canvas_data,
    layout_options,
    layout_group,
    setBackgroundImage,
    reorderObjectCanvas,
    canvasHistory
  } = getScopePage();

  for (const preview of previews) {
    const { id, canvas, dimension, data, template, shadows, themes } = preview;

    canvas.renderLock.add('draw-preview');

    // fabric-history serializes the whole canvas on every add; preview canvases use canvasHistory instead
    canvas.offHistory?.();

    const [width, height, group_x, group_y] = dimension;
    if (data?.deleted_layers) {
      template.fields = template.fields.filter((field) => !data.deleted_layers.includes(field.id));
    }
    const { fields, positioning_options } = template;
    const templateInstance = new Template(template);
    const bannerAnimationPlayer = new Player(canvas);

    if (canvas_data[id]) {
      canvas_data[id]?.backgroundThemeImageMultipleList.removeAll(canvas);
      canvas_data[id]?.outlineList.removeAll(canvas);
    }

    const groupFields = new GroupFields();

    canvas_data[id] = {
      bannerAnimationPlayer,
      templateInstance,
      dimension: {},
      product: {},
      additional_background_theme_image: [],
      background_theme_image: [],
      backgroundThemeImageMultipleList: new BackgroundThemeImageMultipleList(),
      outlineList: new OutlineList(),
      img_from_bk: [],
      uploaded_image: {},
      product_image_settings: [],
      originCoords: [],
      textCoords: [],
      multiLineTextCoords: [],
      stTextCoords: [],
      imgCoords: [],
      stImgCoords: [],
      lineCoords: [],
      iconCoords: [],
      imgFromBkCoords: [],
      additionalBkImgCoords: [],
      bkImgCoords: [],
      rectCoords: [],
      additionalRectCoords: [],
      circleCoords: [],
      cirtypeCoords: [],
      smartObjCoords: {},
      spacingFieldPosition: {},
      additionalTexts: [],
      additionalMultiLineTexts: [],
      additionalRectangles: [],
      additionalCircles: [],
      additionalSafeZones: [],
      additionalLines: [],
      tocLines: [],
      groupFields,
      safeZone: [],
      _data: data,
      additionalSmartObjects: [],
      additionalCutLines: []
    };
    let group_fields = '';

    groupFields.instance_id = id;
    groupFields.on(EVENTS_GROUP_FIELDS.UPDATED, onUpdateGroupFields);

    const usersOrder = parseJsonData(canvas_data[id]._data.users_fields_order, null);
    let backgroundIndex = 0;
    let bgThemeImageIndex = 0;
    let tableIndex = 0;

    fields.forEach((field) => {
      if (usersOrder && ($.inArray(field.id, usersOrder) > -1)) {
        let options = JSON.parse(field.options);
        options['Order'] = $.inArray(field.id, usersOrder) + 1;
        field.options = JSON.stringify(options);

        if (field.type === 'HTML') {
          field.order = options['Order'];
        }
      }

      if (field.type === 'Product Dimensions') {
        const options = JSON.parse(field.options);
        canvas_data[id].product['left'] = parseInt(options.X);
        canvas_data[id].product['top'] = parseInt(options.Y);
        canvas_data[id].product['width'] = parseInt(options.Width);
        canvas_data[id].product['height'] = parseInt(options.Height);
        canvas_data[id].product['alignment'] = options.Alignment;
      } else if (field.type === 'Product Image') {
        const options = JSON.parse(field.options);
        options['id'] = field.id;
        canvas_data[id].product_image_settings.push(options);
      } else if (field.type === 'Background Theme Image') {
        const options = JSON.parse(field.options);
        const bt_image = {};
        let borderOptions = {border_color: '', border_width: 0};
        // Prefer the per-instance related field (parallel indexed array, like the other bk_img_*);
        // fall back to the template's Option2.
        const relatedField = {
          ...RELATED_FIELD_DEFAULT,
          ...parseJsonData(data['bk_img_related_field']?.[bgThemeImageIndex], parseRelatedFieldOptions(options)),
        };

        if (options['Option2']) {
          borderOptions = JSON.parse(options['Option2']);
        }
        
        bt_image['id'] = field.id;
        bt_image['name'] = field.name;
        bt_image['stroke'] = borderOptions['border_color'] ?? '';
        bt_image['strokeWidth'] = borderOptions['border_width'] ?? 0;
        bt_image['relatedField'] = relatedField;
        bt_image['left'] = parseInt(options.X);
        bt_image['top'] = parseInt(options.Y);
        bt_image['width'] = parseInt(options.Width);
        bt_image['height'] = parseInt(options.Height);
        bt_image['order'] = +options.Order || +field.order || 0;
        bt_image['crop'] = options['Option5'] === 'crop';
        bt_image['moveable'] = options['Moveable'] === 'Yes';
        bt_image['placeholder'] = options['Placeholder'];
        bt_image['filename'] = options['Filename'];
        bt_image['Object Fit'] = options['Object Fit'] ? options['Object Fit'] : false;
        bt_image['Object Fill'] = options['Object Fill'];
        bt_image['Hidden'] = options['Hidden'] ?? false;
        bt_image['Group Name'] = getGroupNameByAddFieldId(
          String(field.id),
          canvas_data[id]
        );
        bt_image['Custom Shadow'] = options['Custom Shadow'] ?? null;

        try {
          bt_image['masks'] = JSON.parse(options.Option4);
        } catch (error) {
          //do nothing, there is no mask
        }

        canvas_data[id].background_theme_image.push(bt_image);
        bgThemeImageIndex++;
      } else if (field.type === FIELD_TYPE_BACKGROND_THEME_IMAGE_MULTIPLE) {
        let inputData = data?.background_theme_image_multiple?.[backgroundIndex] || '[]';
        const backgroundField = new BackgroundThemeImageMultipleField(field);
        canvas_data[id].backgroundThemeImageMultipleList.addFieldId(backgroundField.getId());

        try {
          (JSON.parse(inputData) || []).forEach((data) => {
            canvas_data[id].backgroundThemeImageMultipleList.add(
              new BackgroundThemeImageMultiple(
                backgroundField,
                new BackgroundThemeImageMultipleInputData(data.url, data),
                template
              )
            );
          });
        } catch (e) {
          console.log(e);
        }
        
        backgroundIndex++;
      } else if (field.type === FIELD_TYPE_OUTLINE) {
        let fileOutlineIdData = (data?.file_outline_id_data || [])
          .map(data => {
            const parseData = JSON.parse(data);
            return new OutlineInputData(parseData.url, parseData);
          }).find(data => data.fieldId === field.id);
        
        const outlineField = templateInstance.getFieldById(field.id);

        if (fileOutlineIdData) {
          canvas_data[id].outlineList.add(
            new Outline(
              outlineField,
              fileOutlineIdData,
              templateInstance
            )
          );
        }
        
        canvas_data[id].outlineList.fieldsIds.push(field.id);
      } else if (field.type === 'Image From Background') {
        const options = JSON.parse(field.options);
        const bt_image = {};
        bt_image['name'] = field.name;
        bt_image['left'] = parseInt(options.X);
        bt_image['top'] = parseInt(options.Y);
        bt_image['width'] = parseInt(options.Width);
        bt_image['height'] = parseInt(options.Height);
        bt_image['order'] = parseInt(options.Order);
        bt_image['crop'] = options['Option5'] === 'crop';
        bt_image['moveable'] = options['Moveable'] === 'Yes';
        bt_image['Group Name'] = options['Group Name'];
        canvas_data[id].img_from_bk.push(bt_image);
      } else if (
        field.type === FIELD_TYPE_ADDITIONAL_FIELDS
        && canvas_data[id]._data.additional_background_images
        && canvas_data[id]._data.add_bk_img_duplicate_data
      ) {
        initAdditionalBackgroundThemeImage(canvas_data, id);
      } else if (field.type === 'Canvas') {
        const options = JSON.parse(field.options);
        canvas_data[id].dimension['width'] = parseInt(options.Width);
        canvas_data[id].dimension['height'] = parseInt(options.Height);
        canvas_data[id].dimension['left'] = options.X ? parseInt(options.X) : 0;
        canvas_data[id].dimension['top'] = options.Y ? parseInt(options.Y) : 0;
      } else if (field.type === 'Smart Object') {
        const options = JSON.parse(field.options);
        const groupName = options['Group Name'];
        options.X = data[`${field.element_id}_x`] ? parseInt(data[`${field.element_id}_x`]) : options.X;
        options.Y = data[`${field.element_id}_y`] ? parseInt(data[`${field.element_id}_y`]) : options.Y;
        canvas_data[id].smartObjCoords[groupName] = options;
      } else if (field.type === 'Upload Image') {
        const options = JSON.parse(field.options);
        const groupName = options['Group Name'];
        canvas_data[id].uploaded_image[groupName] = options;
      } else if (field.type === 'Group' && field.name === layout_group) {
        const options = JSON.parse(field.options);
        group_fields = options['Option1'];
      } else if (field.type === 'Field Spacing') {
        const options = JSON.parse(field.options);
        const field_spacing_names = options['Option1'].split(',');
        const spacingFieldValues = options['Option2'].split(',');
        const spacingFieldX = +options['X'];
        let spacingFieldWidth = +options['Width'];
        
        if (spacingFieldWidth == 0) {
          spacingFieldWidth = width;
        }
        
        const spacingFields = [];
        const spacingFieldAlignment = options['Alignment'];
        for (let i = 0; i < field_spacing_names.length; i++) {
          const spacing_field = fields.find((f) => f.name === field_spacing_names[i].trim());
          
          if (spacing_field) {
            const spacing_field_options = JSON.parse(spacing_field.options);
            let spacing_field_width = +spacing_field_options['Width'];
            if (spacing_field.type.includes('Text') && data[spacing_field.element_id]) {
              let { text, styles } = parseText(
                data[spacing_field.element_id],
                '#000000'
              );
              const textBox = new fabric.Text(text, {
                fontFamily: spacing_field_options['Font'],
                fontSize: spacing_field_options['Font Size'],
                styles,
              });
              spacing_field_width = textBox.width;
            }
            
            if (i < field_spacing_names.length - 1) {
              spacing_field_width += +spacingFieldValues[i];
            }
            
            spacingFields.push({
              name: spacing_field.name,
              element_id: spacing_field.element_id,
              width: spacing_field_width,
            });
          }
        }

        let group_width = 0;
        for (let i = 0; i < spacingFields.length; i++) {
          group_width += spacingFields[i].width;
        }

        let x = spacingFieldX;
        if (spacingFieldAlignment === 'center') {
          x += (spacingFieldWidth - group_width) / 2;
        } else if (spacingFieldAlignment === 'right') {
          x += spacingFieldWidth - group_width;
        }

        canvas_data[id].spacingFieldPosition[spacingFields[0].name] = {
          x,
          width: spacingFields[0].width,
        };
        
        for (let i = 1; i < spacingFields.length; i++) {
          x += spacingFields[i - 1].width;
          canvas_data[id].spacingFieldPosition[spacingFields[i].name] = {
            x,
            width: spacingFields[i].width,
          };
        }
      } else if (field.type === FIELD_TYPE_SAFE_ZONE) {
        canvas_data[id].safeZone.push(field.element_id);
      }
      if (field.type === 'HTML') {

        if (!canvas_data[id]._data.html_tables) {
          canvas_data[id]._data.html_tables = [];
        }

        if (canvas_data[id]?._data?.html_tables?.[tableIndex] === "") {
            // it's set and it's an empty string check if it was removed by the import process or its a new template.
          if (canvas_data[id]?._data?.removed_html_tables?.[tableIndex] !== undefined) {
              // it's set.. we continue to the next field
              tableIndex++
              return;

          }
        }

        const options = parseJsonData(field.options, null);
        const data = parseJsonData(options['Option1'], null);

        if (data) {
          const table = initDataBuilderTable(data);
          table.styles.setRules({
            'font-family': options['Font'],
            'font-size': `${options['Font Size']}px`,
            'text-align': options['Alignment'],
            'color': options['Font Color'],
          });

          // here we should use false because we don't want to get table column mode properties, 
          // during rendering it will be decided to render table on canvas in column mode or not,
          const tableObj = table.toData(false);
          const normalizedFieldOptions = parseJsonData(field.options, {});
          const hasSavedUserOrder = usersOrder && ($.inArray(field.id, usersOrder) > -1);
          if (hasSavedUserOrder) {
            normalizedFieldOptions['Order'] = $.inArray(field.id, usersOrder) + 1;
          }

          tableObj.fieldOptions = JSON.stringify(normalizedFieldOptions);
          tableObj.realId = field.id;
          tableObj.respectLayerOrder = hasSavedUserOrder;
          
          const existingTableIndex = canvas_data[id]._data.html_tables.findIndex(
            table => parseJsonData(table, null)?.id === tableObj.id
          );

          if (existingTableIndex > -1) {
            const existingTable = parseJsonData(
              canvas_data[id]._data.html_tables[existingTableIndex],
              null
            );

            if (existingTable) {
              existingTable.fieldOptions = existingTable.fieldOptions || JSON.stringify(normalizedFieldOptions);
              existingTable.realId = existingTable.realId || field.id;
              if (hasSavedUserOrder) {
                existingTable.respectLayerOrder = true;

                const existingFieldOptions = parseJsonData(existingTable.fieldOptions, {});
                existingFieldOptions['Order'] = $.inArray(field.id, usersOrder) + 1;
                existingTable.fieldOptions = JSON.stringify(existingFieldOptions);
              }
              canvas_data[id]._data.html_tables[existingTableIndex] = JSON.stringify(existingTable);
            }
          } else if (!canvas_data[id]._data.table_was_removed) {
            canvas_data[id]._data.html_tables[tableIndex] = JSON.stringify(tableObj);
          }
          
          tableIndex++
        }
      }
    });
    if (
      !canvas_data[id].dimension['width'] ||
      !canvas_data[id].dimension['height']
    ) {
      canvas_data[id].dimension['width'] = width;
      canvas_data[id].dimension['height'] = height;
      canvas_data[id].dimension['left'] = 0;
      canvas_data[id].dimension['top'] = 0;
    }
    let usedSmartKeys = [];
    // ADDITIONAL FIELDS
    for (const key of Object.keys(canvas_data[id]._data)) {
      if (key.startsWith(ADDITIONAL_TEXT_PREFIX_ELEMENT_ID) && key.length === 22) {
        canvas_data[id].additionalTexts.push(key);
      }
      if (key.startsWith(ADDITIONAL_RECTANGLE_PREFIX_ELEMENT_ID) && key.length === 27) {
        canvas_data[id].additionalRectangles.push(key);
      }
      if (key.startsWith(ADDITIONAL_CIRCLE_PREFIX_ELEMENT_ID) && key.length === 24) {
        canvas_data[id].additionalCircles.push(key);
      }
      if (key.startsWith(ADDITIONAL_MULTI_LINE_TEXT_FIELD_PREFIX_ELEMENT_ID) && key.length === 33) {
        canvas_data[id].additionalMultiLineTexts.push(key);
      }
      if (key.startsWith(ADDITIONAL_SAFE_ZONE_PREFIX_ELEMENT_ID) && key.length === 27) {
        canvas_data[id].additionalSafeZones.push(key);
      }
      if (key.startsWith(ADDITIONAL_LINE_PREFIX_ID) && key.length === 22) {
        canvas_data[id].additionalLines.push(key);
      }
      if (key.startsWith(ADDITIONAL_CUT_LINE_PREFIX_ELEMENT_ID) && key.length === 26) {
        canvas_data[id].additionalCutLines.push(key);
      }
      if (key.startsWith(TOC_LINE_PREFIX_ID) && key.length === 22) {
        canvas_data[id].tocLines.push(key);
      }
      if (key.startsWith(SMART_OBJECT)) {
        let param = key.split('_').pop();
        if (param === 'options') {
          let element_id = key.replace('_' + param, '');
          if (fields.find(f => f.element_id === element_id) === undefined) {
            canvas_data[id].additionalSmartObjects.push(element_id);

            const options = {};
            const groupName = data[`${element_id}_group_name`];
            options.X = parseInt(data[`${element_id}_x`]);
            options.Y = parseInt(data[`${element_id}_y`]);
            canvas_data[id].smartObjCoords[groupName] = options;
          }
        }
      }
    }
    canvas_data[id].additionalMultiLineTexts.sort()
    canvas_data[id].tocLines.sort((a, b) => {
      const orderA = Number(canvas_data[id]._data[`${a}_order`]);
      const orderB = Number(canvas_data[id]._data[`${b}_order`]);

      if (Number.isFinite(orderA) && Number.isFinite(orderB) && orderA !== orderB) {
        return orderA - orderB;
      }

      const offsetYA = Number(canvas_data[id]._data[`${a}_offset_y`]);
      const offsetYB = Number(canvas_data[id]._data[`${b}_offset_y`]);

      if (Number.isFinite(offsetYA) && Number.isFinite(offsetYB) && offsetYA !== offsetYB) {
        return offsetYA - offsetYB;
      }

      return a.localeCompare(b);
    })
    canvas_data[id].additionalSmartObjects.sort()
    // END ADDITIONAL FIELDS

    const previewBoundingBoxData = {
      templateId: id,
      data: []
    };

    const params = {
      fields,
      positioning_options,
      data,
      canvas,
      id,
      group_fields,
      shadows,
      dimension,
      previewBoundingBoxData,
      batchProductImageMode: Boolean(preview.batchProductImageMode),
      isNeedReRenderCanvas: true
    };

    // commenting out as per POR-9462 until it gets fixed  (related tickets POR-9183, POR-9394)

    /*canvasEventBroker.on(CANVAS_EVENTS.REDRAW_ADDITIONAL_MULTI_LINE_TEXT, async (event) => {
      await drawAdditionalMultiLineText(
        {event: {name: CANVAS_EVENTS.REDRAW_ADDITIONAL_MULTI_LINE_TEXT, data: event}, ...params}
      );
    })*/

    // canvasEventBroker.on(CANVAS_EVENTS.REDRAW_ADDITIONAL_MULTI_LINE_TEXT, async (event) => {
    //   let splitBulletChildren = canvas_data?.[id]?.['_data']?.[event.parentElementId + '_split_bullets_children'] || null;
    //   if (splitBulletChildren?.ids) {
    //     await drawAdditionalMultiLineText(
    //       {event: {name: CANVAS_EVENTS.REDRAW_ADDITIONAL_MULTI_LINE_TEXT, type: "splitBulletChildren", data: event}, ...params}
    //     );
    //   }
    // })

    // The background image must be added before the final layer ordering.
    await drawBackgroundColor({ ...params, template });

    // canvas_data may be cleared during the await (pagination / rerender), skip the stale preview
    if (!canvas_data[id]) {
      canvas.renderLock.remove('draw-preview');
      continue;
    }

    createGroupFields(params);
    await setBackgroundColor({ ...params, themes, template });
    drawBackgroundMockup(params);
    // drawUploadedBackgroundImage(params);
    drawRectangle({ ...params, themes });
    drawCircle({ ...params, themes });
    drawAdditionalRectangle(params);
    drawAdditionalCircle(params);
    drawSafeZone(params)
    drawAdditionalSafeZone(params)
    drawLine(params);
    drawAdditionalLine(params)
    drawAdditionalCutLine(params);

    const promiseHTML = drawHtml(params);

    drawStaticText(params);
    drawStroke(params);
    drawMarker(params);
    drawImageList(params);
    drawOverlayArea(params);

    if (layout_options && layout_options.show_stroke) {
      const layoutOptionsParam = {
        layout_options,
        width,
        height,
        canvas
      };

      drawLayoutStroke(layoutOptionsParam);
    }

    //need this to guarantee that first render "Multi Line", maybe use for all another types before markup fields
    //markup fields can take position of rendered items
    const multiLineTextPromise = drawMultiLineText(params, canvasEventBroker)
      .then(() => drawAdditionalMultiLineText(params));
    
    const promise = Promise.all([
      promiseHTML,
      drawUploadedImage(params),
      drawImageFromBackground(params),
      drawStaticImage(params),
      setBackgroundImage(params),
      setAdditionalBackgroundImage(params),
      drawProductImage(params),
      drawUploadedBackgroundImage(params),
      canvas_data[id].backgroundThemeImageMultipleList.render(canvas),
      canvas_data[id].outlineList.render(canvas),
      drawText(params),
      drawAdditionalText(params),
      multiLineTextPromise,
      drawTocLine(params),
      drawIcons(params),
      drawAdditionalIcons(params),
      drawAdditionalHtmlTable(params)
    ])
      .finally(async () => {
        try {
          drawTemplateGuidelines(params);
          await recalculateOrderForBgMultiple(canvas_data[id]);
          await drawSmartObject(params);
          reorderObjectCanvas(canvas);
          $('.btn-share-proof').removeAttr('disabled')
          $('.btn-update-share-proof').removeAttr('disabled');
          $('.btn-delta-update-share-proof').removeAttr('disabled');
          $('.btn-new-version').removeAttr('disabled');
          $('.btn-share-assets').removeAttr('disabled');
          $('.btn-share-images-psd').removeAttr('disabled');
          $('.btn-share-images-publish').removeAttr('disabled');
        } finally {
          canvas.renderLock.remove('draw-preview');
          canvas.renderAll();
          ShowPageEventBroker.fire(SHOW_PAGE_EVENTS.LAYOUT_READY);
        }
      }).catch((e) => console.log(e));

    promises.push(promise);

    boundingBoxData.push(params.previewBoundingBoxData);

    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.cornerColor = '#ffffff';
    fabric.Object.prototype.cornerStyle = 'circle';
    fabric.Object.prototype.cornerSize = CORNER_SIZE;

    fabric.Object.prototype.cornerStrokeColor = '#000000';
    fabric.Object.prototype.setControlsVisibility({
      tl: true,
      tr: true,
      br: true,
      bl: true,
      ml: true,
      mt: true,
      mr: true,
      mb: true,
      mtr: true,
    });
  }

  return Promise.allSettled(promises).then(() => {

    updateLayoutBoundingBoxes(boundingBoxData);

    defaultViewLayoutInit();
    canvasHistory.clean();

    canvasHistory.push(_.cloneDeep({
      previewChanges: layoutChanges,
      previews: previews.map(({ id, canvas }) => {
        return {
          instance_id: id,
          objects: canvas.getObjects()
        };
      }),
    }));

    // Initialize stroke settings after all previews are loaded
    initStrokeSettings();
  });
};

function defaultViewInit() {
  const defaultView = localStorage.getItem('defaultView') || '';
  $(`input[name=default_view][value="${defaultView}"]`).attr({ 'checked': true });
  if (defaultView && defaultView !== 'layout') {
    $(`.btn-${defaultView}`).trigger('click');
  }
}

function onUpdateGroupFields(event) {
  const { updateLayoutChanges } = getScopePage();
  updateLayoutChanges(event.instance_id, 'group_fields', JSON.stringify(event.items));
}

function getGroupOrder() {
  const DEFAULT_ORDER = 9999;
  if (!this?.canvas) return DEFAULT_ORDER;

  const preview = window.previews?.find(p => p.id === this.canvas.instance_id);
  const usersFieldsOrder = preview?.data?.users_fields_order;

  const fieldId = this?.field_id;
  if (usersFieldsOrder && fieldId != null) {
    const mapped = Number(usersFieldsOrder[fieldId]);
    if (Number.isFinite(mapped)) return mapped;
  }

  const orders = (this._objects || [])
    .map(o => Number(o?.order))
    .filter(Number.isFinite);

  if (orders.length) return Math.min(...orders);

  return DEFAULT_ORDER;
}

function createGroupFields({ id, canvas, data }) {
  const parseValue = parseJsonData(data?.group_fields, []);
  const groupFields = canvas_data[id].groupFields;

  groupFields.setItems(parseValue);

  const createFabricGroup = (groupValue) => {
    const nestedGroups = (Array.isArray(groupValue.fields) ? groupValue.fields : [])
      .filter(field => field && typeof field === 'object')
      .map(createFabricGroup);
    const group = new fabric.Group(nestedGroups, {
      id: groupValue.id,
      name: groupValue.name,
      opacity: Number.isFinite(Number(groupValue.opacity)) ? Number(groupValue.opacity) : 1,
      globalCompositeOperation: groupValue.blendingMode || 'source-over',
      getGroupOrder,
      order: getGroupOrder.bind(this)()
    });
    group.on('members:changed', function() {
      this.order = this.getGroupOrder();
    })

    return group;
  }

  groupFields.getItems().forEach((groupValue) => {
    canvas.add(createFabricGroup(groupValue));
  });
}

async function recalculateOrderForBgMultiple(canvas) {
  const usersOrder = canvas?._data.users_fields_order ? JSON.parse(canvas._data.users_fields_order) : null;

  if (usersOrder && Object.hasOwn(canvas, 'backgroundThemeImageMultipleList')) {
    canvas.backgroundThemeImageMultipleList.items.forEach(bg => {
      let bg_id = bg.object.real_id + '-' + bg.object.inputDataId;
      if ($.inArray(bg_id, usersOrder) > -1) {
        bg.object.order = parseInt(usersOrder.indexOf(bg_id)) + 1;
      }
    });
  }
}

function updateLayoutBoundingBoxes(boundingBoxesData) {
  const EXCLUDE_KEYS = ['type', 'element_ids[]'];

  const grid = $('#template-group-preview');
  const customer_id = grid.attr('data-customer-id');
  const layout_id = grid.attr('data-layout-id');
  const url = `/banner/${customer_id}/group/${layout_id}/update_bounding_boxes`;

  axios({
    method: 'POST',
    url: url,
    data: boundingBoxesData,
  }).then((res) => {
    for (const boundingBoxData of boundingBoxesData) {
      const preview = previews.find(({ id }) => id === boundingBoxData.templateId);

      if (!preview) {
        continue;
      }

      for (const boundingBoxDataItem of boundingBoxData.data) {
        for (const key in boundingBoxDataItem) {
          if (EXCLUDE_KEYS.includes(key)) {
            continue;
          }

          preview.data[key] = boundingBoxDataItem[key];
        }
      }
    }
  });
}

function defaultViewLayoutInit() {
  const defaultView = localStorage.getItem('defaultView') || '';
  if (defaultView === 'layout') {
    $(`.btn-${defaultView}`).trigger('click');
  }
}
